import { calculateRemainingStencilLoaderVisibleTime } from './stencil-route-transition.business';

type Listener = VoidFunction;

let active = false;
let visibleAt: number | undefined;
let startedAt = 0;
let version = 0;
let hideTimeout: ReturnType<typeof globalThis.setTimeout> | undefined;

const stateListeners = new Set<Listener>();
const startListeners = new Set<Listener>();

const emitState = () => stateListeners.forEach((listener) => listener());

const setActive = (nextActive: boolean) => {
    if (active === nextActive) {
        return;
    }
    active = nextActive;
    emitState();
};

const clearHideTimeout = () => {
    if (hideTimeout !== undefined) {
        globalThis.clearTimeout(hideTimeout);
        hideTimeout = undefined;
    }
};

const hide = (expectedVersion: number) => {
    if (expectedVersion !== version) {
        return;
    }
    visibleAt = undefined;
    setActive(false);
};

const hideAfterMinimumDuration = (expectedVersion: number) => {
    const elapsed = performance.now() - startedAt;
    const visibleElapsed = visibleAt === undefined ? 0 : performance.now() - visibleAt;
    const remainingVisibleTime = calculateRemainingStencilLoaderVisibleTime(elapsed, visibleElapsed);

    if (remainingVisibleTime > 0) {
        hideTimeout = globalThis.setTimeout(() => hide(expectedVersion), remainingVisibleTime);
        return;
    }

    hide(expectedVersion);
};

export const startStencilRouteTransition = (): number => {
    clearHideTimeout();
    version++;
    startListeners.forEach((listener) => listener());
    startedAt = performance.now();
    visibleAt = undefined;
    setActive(true);
    return version;
};

export const finishStencilRouteTransition = (expectedVersion: number, preserveMinimumDuration = true) => {
    if (expectedVersion !== version) {
        return;
    }

    if (preserveMinimumDuration) {
        hideAfterMinimumDuration(expectedVersion);
        return;
    }

    clearHideTimeout();
    hide(expectedVersion);
};

export const markStencilRouteTransitionVisible = () => {
    if (active && visibleAt === undefined) {
        visibleAt = performance.now();
    }
};

export const subscribeToStencilRouteTransition = (listener: Listener): VoidFunction => {
    stateListeners.add(listener);
    return () => {
        stateListeners.delete(listener);
    };
};

export const subscribeToStencilRouteTransitionStart = (listener: Listener): VoidFunction => {
    startListeners.add(listener);
    return () => {
        startListeners.delete(listener);
    };
};

export const getStencilRouteTransitionSnapshot = (): boolean => active;

export const getServerStencilRouteTransitionSnapshot = (): boolean => false;
